var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.805 0H32.061L46.4106 14.3523V41.9129C46.4106 45.2596 43.6729 48 40.3235 48H15.8051C12.4584 48 9.7207 45.2596 9.7207 41.9129V6.08709C9.7207 2.74041 12.4584 0 15.805 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0615 0L46.4111 14.3523H33.6087C32.7556 14.3523 32.0615 13.6555 32.0615 12.8024V0Z",
    fill: "#B71D21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92578 20.4397H35.9837C36.7189 20.4397 37.3197 21.0404 37.3197 21.7756V33.9031C37.3197 34.6383 36.7189 35.2391 35.9837 35.2391H2.92578C2.19059 35.2391 1.58984 34.6383 1.58984 33.9031V21.7756C1.58984 21.0404 2.19069 20.4397 2.92578 20.4397Z",
    fill: "#B71D21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 22.9124H8.54642C8.11845 22.9124 7.77148 23.2593 7.77148 23.6873V27.7746V28.7813V31.9881C7.77148 32.4161 8.11845 32.763 8.54642 32.763C8.97439 32.763 9.32136 32.4161 9.32136 31.9881V29.5562H11.0399C12.8421 29.5562 14.3084 28.09 14.3084 26.2878V26.1809C14.3085 24.3786 12.8422 22.9124 11.04 22.9124ZM12.7586 26.2877C12.7586 27.2354 11.9876 28.0063 11.04 28.0063H9.32136V27.7745V24.4621H11.0399C11.9875 24.4621 12.7585 25.2331 12.7585 26.1807V26.2877H12.7586ZM19.3792 22.9124H16.8858C16.4578 22.9124 16.1108 23.2593 16.1108 23.6873V31.9881C16.1108 32.4161 16.4578 32.763 16.8858 32.763H19.3792C21.1815 32.763 22.6477 31.2968 22.6477 29.4946V26.1809C22.6477 24.3786 21.1815 22.9124 19.3792 22.9124ZM21.0979 29.4945C21.0979 30.4422 20.3269 31.2131 19.3792 31.2131H17.6607V24.4621H19.3792C20.3269 24.4621 21.0979 25.2331 21.0979 26.1807V29.4945ZM26.1507 24.4622V26.6074H29.7429C30.1709 26.6074 30.5179 26.9544 30.5179 27.3824C30.5179 27.8103 30.1709 28.1573 29.7429 28.1573H26.1507V31.9881C26.1507 32.4161 25.8037 32.763 25.3758 32.763C24.9478 32.763 24.6008 32.4161 24.6008 31.9881V23.6873C24.6008 23.2593 24.9478 22.9124 25.3758 22.9124H30.3628C30.7908 22.9124 31.1377 23.2593 31.1377 23.6873C31.1377 24.1153 30.7908 24.4622 30.3628 24.4622H26.1507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.eca5631617f85b240894bff056026264.svg";
export { ForwardRef as ReactComponent };